import React from 'react'
import { observer } from 'mobx-react-lite'

import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'

import { useDebtsUiStore } from '../../hooks/useDebtsUiStore'
import { ANALYTICS_EVENTS, useEvent } from '../../../common'

import { InterestRateAction as GoalInterestRateAction } from '../../../goals/components/actions/InterestRateAction'
import { MonthlyPaymentAction as GoalMonthlyPaymentAction } from '../../../goals/components/actions/MonthlyPaymentAction'
import { OriginalBalanceAction as GoalOriginalBalanceAction } from '../../../goals/components/actions/OriginalBalanceAction'
import { InterestRateAction as DebtInterestRateAction } from '../actions/InterestRateAction'
import { MonthlyPaymentAction as DebtMonthlyPaymentAction } from '../actions/MonthlyPaymentAction'
import { OriginalBalanceAction as AccountOriginalBalanceAction } from '../actions/OriginalBalanceAction'

const DebtDetailsTab = () => {
  const { onEvent } = useEvent()
  const { selectedDebtChartData: debt } = useDebtsUiStore()

  React.useEffect(() => onEvent(ANALYTICS_EVENTS.DEBT_DETAILS_VIEW), [])

  return (
    <Stack bgcolor="background.paper">
      {debt?.goal && (
        <>
          <GoalMonthlyPaymentAction goal={debt.goal} />
          <Divider />

          <GoalInterestRateAction goal={debt.goal} />
          <Divider />

          <GoalOriginalBalanceAction goal={debt.goal} />
          <Divider />
        </>
      )}

      {!debt?.goal && debt?.account && (
        <>
          <DebtMonthlyPaymentAction debt={debt} />
          <Divider />

          <DebtInterestRateAction debt={debt} />
          <Divider />

          <AccountOriginalBalanceAction debt={debt} />
          <Divider />
        </>
      )}
    </Stack>
  )
}

export default observer(DebtDetailsTab)
